export const isReturningCondition = {
    id: 'is-returning',
    category: 'conditions',
    value: {
        includeValues: [{ value: false, label: 'CONDITION_SELECT_IS_RETURNING' }, { value: true, label: 'CONDITION_SELECT_IS_NEW' }],
    },
};
//# sourceMappingURL=is-returning-condition.value.js.map